import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "@store/store";
import { RoleBasedState } from "@interfaces/RoleBasedState";
import { getFromStorage } from "@utilities/storageService";
import { getRoleBasedProperty } from "@components/RoleBasedProperty";

let auth = getFromStorage("auth");
let userRole = null;

if (auth && JSON.parse(auth).userInfo) {
    userRole = JSON.parse(auth).userInfo.role;
}

const initialState: RoleBasedState = getRoleBasedProperty(userRole);

export const roleBasedPropertySlice = createSlice({
    name: "roleBasedProperty",
    initialState,
    reducers: {
        setRoleBasedProperty: (state: RoleBasedState, Action: { payload: RoleBasedState; type: string }) => {
            state.adminMenu = Action.payload.adminMenu;
            state.donorMenu = Action.payload.donorMenu;
            state.accountMenu = Action.payload.accountMenu;
        },
    },
});

export const { setRoleBasedProperty } = roleBasedPropertySlice.actions;

export const selectRoleBasedProperty = (state: RootState) => state.roleBasedProperty;

export default roleBasedPropertySlice.reducer;
